module.exports = __webpack_public_path__ + "img/theroom_amp.ac9c708b.jpg";